module.exports = __webpack_public_path__ + "img/VideoTitleMine.3a223559.png";